var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("任务详情")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pageTab" }, [
          _c("div", { staticClass: "detail" }, [
            _c(
              "div",
              { staticClass: "itemBox" },
              [
                _c(
                  "el-tabs",
                  { attrs: { type: "card", value: "first" } },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "任务信息", name: "first" } },
                      [
                        _c(
                          "div",
                          { staticClass: "iemBoxContent" },
                          [
                            _c("div", { staticClass: "modelTitle" }, [
                              _vm._v("任务详情"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("编号："),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.detail.jobNo))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("接单类型："),
                              ]),
                              _vm._v(" "),
                              _vm.detail.applyType == 0
                                ? _c("div", [_vm._v("所有")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.applyType == 1
                                ? _c("div", [_vm._v("企业")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.applyType == 2
                                ? _c("div", [_vm._v("临勤")])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("发布人："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.detail.creatorName)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("创建时间："),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.detail.gmtCreate))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("发布范围："),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.detail.rangeName))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("任务名称："),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.detail.title))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("任务地址："),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.detail.address))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("订单状态："),
                              ]),
                              _vm._v(" "),
                              _vm.detail.status == 0
                                ? _c("div", [_vm._v("待支付")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.status == 1
                                ? _c("div", [_vm._v("待发布")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.status == 2
                                ? _c("div", [_vm._v("发布中")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.status == 3
                                ? _c("div", [_vm._v("已收单")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.status == 4
                                ? _c("div", [_vm._v("实做中")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.status == 5
                                ? _c("div", [_vm._v("已取消")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.status == 6
                                ? _c("div", [_vm._v("已结算")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.status == 8
                                ? _c("div", [_vm._v("已完成")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.status == 9
                                ? _c("div", [_vm._v("已关闭")])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm.detail.status == 5
                              ? _c("div", { staticClass: "infoItem" }, [
                                  _c("div", { staticClass: "infoTitle" }, [
                                    _vm._v("取消原因："),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.detail.cancelReason)),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("发布时间："),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.detail.actionAt))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("需求人数："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.detail.membersNum)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("用户任务单价："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.detail.customUnitPrice) + "元/小时"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v(
                                  "身高要求：" + _vm._s(_vm.detail.highName)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v(
                                  "职业要求：" +
                                    _vm._s(_vm.detail.careerTypeName) +
                                    "-" +
                                    _vm._s(_vm.detail.levelTypeName)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v(
                                  "着装要求：" +
                                    _vm._s(_vm.detail.dressTypeName)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v(
                                  "年龄要求：" + _vm._s(_vm.detail.ageTypeName)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v(
                                  "用工场景：" +
                                    _vm._s(_vm.detail.employSceneTypeName)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("任务金额："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v("￥" + _vm._s(_vm.detail.price)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("任务退款："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v("￥" + _vm._s(_vm.detail.returnFee)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("保安预期收益："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" + _vm._s(_vm.detail.expectedSecPrice)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("保安结算金额："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v("￥" + _vm._s(_vm.detail.settledAmount)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("保安扣款："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" + _vm._s(_vm.detail.reductionAmount)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "borderBottom" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("平台预期服务费："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" + _vm._s(_vm.detail.platformServiceFee)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("平台实际结算："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.detail.platformSettledAmount)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("平台服务费（挂帐）："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.detail.platformReductionAmount)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "borderBottom" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "modelTitle" }, [
                              _vm._v("服务时长"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("总时长："),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.detail.hour))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("实做时间："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.detail.jobStart) +
                                    "至" +
                                    _vm._s(_vm.detail.jobEnd)
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _c("div", { staticClass: "infoTitle" }, [
                                _vm._v("服务分班："),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.detail.num) + "班"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.detail.jobScheduleList,
                              function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "infoItem" },
                                  [
                                    _c("div", { staticClass: "infoTitle" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            item.scheduleType == 0
                                              ? "早班"
                                              : item.scheduleType == 1
                                              ? "中班"
                                              : "夜班"
                                          ) +
                                          "：\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(item.startTime) +
                                          "-" +
                                          _vm._s(item.endTime)
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "borderBottom" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "modelTitle" }, [
                                _vm._v("支付详情"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "infoItem" }, [
                                _c("div", { staticClass: "infoTitle" }, [
                                  _vm._v("第三方支付流水号："),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "  " +
                                      _vm._s(
                                        _vm.detail.billDetail
                                          ? _vm.detail.billDetail
                                              .thirdPaymentOrder
                                          : "无"
                                      )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "infoItem" }, [
                                _c("div", { staticClass: "infoTitle" }, [
                                  _vm._v("平台单号："),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "  " +
                                      _vm._s(
                                        _vm.detail.billDetail
                                          ? _vm.detail.billDetail.paymentOrder
                                          : "无"
                                      )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "infoItem" }, [
                                _c("div", { staticClass: "infoTitle" }, [
                                  _vm._v("支付方式："),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.detail.payWay == 0
                                          ? "钱包"
                                          : _vm.detail.payWay == 2
                                          ? "银行卡"
                                          : _vm.detail.payWay == 3
                                          ? "支付宝"
                                          : _vm.detail.payWay == 4
                                          ? "微信"
                                          : "无"
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "infoItem" }, [
                                _c("div", { staticClass: "infoTitle" }, [
                                  _vm._v("支付状态："),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.detail.payStatus == 0
                                          ? "待支付"
                                          : _vm.detail.payStatus == 1
                                          ? "已支付"
                                          : "无"
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "infoItem" }, [
                                _c("div", { staticClass: "infoTitle" }, [
                                  _vm._v("结算状态："),
                                ]),
                                _vm._v(" "),
                                _vm.detail.cashType == 0
                                  ? _c("div", [_vm._v("未结算")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.detail.cashType == 1
                                  ? _c("div", [_vm._v("结算中")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.detail.cashType == 2
                                  ? _c("div", [_vm._v("已结算")])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "infoItem" }, [
                                _c("div", { staticClass: "infoTitle" }, [
                                  _vm._v("退款状态："),
                                ]),
                                _vm._v(" "),
                                _vm.detail.refundStatus == 0
                                  ? _c("div", [_vm._v("无退款")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.detail.refundStatus == 1
                                  ? _c("div", [_vm._v("处理中")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.detail.refundStatus == 2
                                  ? _c("div", [_vm._v("已完成")])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _vm.detail.refundStatus == 2
                                ? _c("div", { staticClass: "infoItem" }, [
                                    _c("div", { staticClass: "infoTitle" }, [
                                      _vm._v("退款时间："),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.detail.refundAt)),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "itemBox" },
              [
                _c(
                  "el-tabs",
                  {
                    attrs: { type: "card", value: "first" },
                    on: { "tab-click": _vm.handleClick1 },
                    model: {
                      value: _vm.activeName1,
                      callback: function ($$v) {
                        _vm.activeName1 = $$v
                      },
                      expression: "activeName1",
                    },
                  },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "抢单人员列表", name: "0" } },
                      [
                        _c(
                          "div",
                          { staticClass: "iemBoxContent" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "detail",
                                staticStyle: {
                                  "align-items": "center",
                                  "margin-bottom": "10px",
                                },
                              },
                              [
                                _c("div", [
                                  _vm._v("已抢单人数" + _vm._s(_vm.total)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.tableData9, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  class: [
                                    "listItem",
                                    _vm.selectData.bodyguardId ==
                                    item.bodyguardId
                                      ? "active"
                                      : "",
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.select(item)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "img" }, [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          item.headimgUrl ||
                                          require("@/assets/imgs/headImg.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(item.bodyguardName || item.name)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  item.status == 2
                                    ? _c(
                                        "div",
                                        { staticStyle: { flex: "none" } },
                                        [
                                          _vm._v(
                                            "(" + _vm._s(item.statusName) + ")"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("el-pagination", {
                              attrs: {
                                layout: "prev, pager, next",
                                total: _vm.total,
                                small: "",
                              },
                              on: { "current-change": _vm.jobApplicationList },
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "实做人员列表", name: "1" } },
                      [
                        _c(
                          "div",
                          { staticClass: "iemBoxContent" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "detail",
                                staticStyle: { "align-items": "center" },
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    "\n                    共需" +
                                      _vm._s(_vm.detail.membersNum) +
                                      "人，已加入" +
                                      _vm._s(_vm.people) +
                                      "人，已取消" +
                                      _vm._s(_vm.detail.cancelNum || "0") +
                                      "人\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.add },
                                  },
                                  [_vm._v(_vm._s(_vm.edit ? "保存" : "编辑"))]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.jobWorkList, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  class: [
                                    "listItem",
                                    _vm.selectData.bodyguardId ==
                                    item.bodyguardId
                                      ? "active"
                                      : "",
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.select(item)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "img" }, [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          item.headimgUrl ||
                                          require("@/assets/imgs/headImg.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("div", [_vm._v(_vm._s(item.name))]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(item.workStatusName)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-left": "auto",
                                      },
                                    },
                                    [
                                      _c("div", [_vm._v("沟通记录")]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(_vm._s(item.interactNum)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/imgs/icon_right.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.edit
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      width: "100px",
                                      "font-size": "28px",
                                      margin: "20px 80px 0",
                                      display: "inline-block",
                                    },
                                    attrs: { size: "small" },
                                    on: { click: _vm.addlist },
                                  },
                                  [_vm._v("+")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-pagination", {
                              attrs: {
                                layout: "prev, pager, next",
                                total: _vm.people,
                                small: "",
                              },
                              on: {
                                "current-change": _vm.baoanHandleCurrentChange,
                              },
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "变更记录", name: "2" } },
                      [
                        _c(
                          "div",
                          { staticClass: "iemBoxContent" },
                          [
                            _c(
                              "el-table",
                              {
                                ref: "scrollTable",
                                staticStyle: { width: "100%" },
                                attrs: { data: _vm.tableData },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { prop: "id", label: "编号" },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "sourceBodyguardName",
                                    label: "原人员",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "replaceBodyguardName",
                                    label: "变更",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "reason", label: "原因" },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "gmtCreate", label: "时间" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-pagination", {
                              attrs: {
                                "page-sizes": [10, 20, 30, 50],
                                "page-size": _vm.pageSize,
                                layout: "total, prev, pager, next,sizes",
                                total: _vm.total,
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.handleCurrentChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "itemBox" },
              [
                _c(
                  "el-tabs",
                  {
                    attrs: { type: "card" },
                    on: { "tab-click": _vm.handleClick },
                    model: {
                      value: _vm.activeName,
                      callback: function ($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName",
                    },
                  },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "沟通记录", name: "0" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "iemBoxContent",
                            staticStyle: { "overflow-y": "scroll" },
                          },
                          [
                            _vm.selectData && _vm.selectData.imType == 0
                              ? _c(
                                  "el-select",
                                  {
                                    ref: "select",
                                    staticStyle: {
                                      "margin-right": "auto",
                                      "margin-bottom": "10px",
                                    },
                                    attrs: {
                                      placeholder: "请选择消息发出人",
                                      filterable: "",
                                    },
                                    on: {
                                      "visible-change": _vm.handleVisibleChange,
                                      change: _vm.communicateList,
                                    },
                                    model: {
                                      value: _vm.selectPeople,
                                      callback: function ($$v) {
                                        _vm.selectPeople = $$v
                                      },
                                      expression: "selectPeople",
                                    },
                                  },
                                  _vm._l(
                                    _vm.peopleList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.name,
                                          value: item.memberId,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.tableData1, function (item, index) {
                              return _vm.tableData1.length > 0
                                ? _c("div", { key: index }, [
                                    item.isSend == 0
                                      ? _c(
                                          "div",
                                          { staticClass: "communicate" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "img" },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          item.senderAvatar ||
                                                          require("@/assets/imgs/headImg.png"),
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item.gmtCreate) +
                                                      "\n                      "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "auto",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.senderName
                                                        ) +
                                                        "（" +
                                                        _vm._s(
                                                          item.senderType == 1
                                                            ? "客户"
                                                            : item.senderType ==
                                                              2
                                                            ? "临勤"
                                                            : item.senderType ==
                                                              3
                                                            ? "保安公司"
                                                            : item.senderType ==
                                                              4
                                                            ? "保安公司员工"
                                                            : "平台客服"
                                                        ) +
                                                        "）\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "left",
                                                },
                                              },
                                              [
                                                item.message.type == 0 ||
                                                item.message.type == 2 ||
                                                item.message.type == 3 ||
                                                item.message.type == 4 ||
                                                item.message.type == 5 ||
                                                item.message.type == 6
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "message",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              item.message
                                                                .context
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 1
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "message",
                                                      },
                                                      [
                                                        _c("el-image", {
                                                          staticStyle: {
                                                            width: "200px",
                                                            height: "200px",
                                                          },
                                                          attrs: {
                                                            src: item.message
                                                              .context,
                                                            alt: "",
                                                            "preview-src-list":
                                                              [
                                                                item.message
                                                                  .context,
                                                              ],
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 7
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goJob(
                                                              item.message.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-card",
                                                          {
                                                            staticClass:
                                                              "box-card1 other",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          任务编号：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .jobNo
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardStatus",
                                                                  },
                                                                  [
                                                                    item.message
                                                                      .status ==
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "待支付"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    1
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "待发布"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    2
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "发布中"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    3
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已收单"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    4
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "实做中"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    5
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已取消"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    6
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已结算"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        任务名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        地址：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .address
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        时间：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobStart
                                                                    ) +
                                                                    "-" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobEnd
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          单价：￥" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .unitPrice
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          任务时长：" +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "maxTime"
                                                                          )(
                                                                            item
                                                                              .message
                                                                              .hour *
                                                                              60
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          总金额：￥" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .price
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 8
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.gocomplaint(
                                                              item.message
                                                                .jobComplainId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-card",
                                                          {
                                                            staticClass:
                                                              "box-card1 other",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          投诉编号：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .complainNo
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardStatus",
                                                                  },
                                                                  [
                                                                    item.message
                                                                      .jobComplainStatus ==
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "未处理"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .jobComplainStatus ==
                                                                    1
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已处理"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .jobComplainStatus ==
                                                                    2
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已撤销"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        任务名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        被投诉人名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .respondentName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        投诉人名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .complainantName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        投诉原因：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .complainMemo
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          提交时间：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .submitAt
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          责任人类型：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .dutyType ==
                                                                            1
                                                                            ? "用户"
                                                                            : item
                                                                                .message
                                                                                .dutyType ==
                                                                              2
                                                                            ? "保安(临勤)"
                                                                            : "保安(公司)"
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 9
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.godefault(
                                                              item.message
                                                                .violateLogId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-card",
                                                          {
                                                            staticClass:
                                                              "box-card1 other",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          违约编号：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .violateLogNo
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardStatus",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .violateLogStatus ==
                                                                            0
                                                                            ? "待支付"
                                                                            : "已支付"
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        任务名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        违约类型：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .voilateTypeTitle
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        违约规则：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .voilateMemo
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          违约：￥" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .violateAmount
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          退还：￥" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .refundAmount ||
                                                                            0
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 10
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goappeal(
                                                              item.message
                                                                .appealId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-card",
                                                          {
                                                            staticClass:
                                                              "box-card1 other",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          考勤申诉编号：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .appealNo
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardStatus",
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .operateStatusTitle
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        任务名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        考勤日期：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .dueAtIn
                                                                    ) +
                                                                    "-" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .dueAtOut
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        打卡状态：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .signStatusTitle
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        申诉原因：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .appealReason
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.isSend == 1
                                      ? _c(
                                          "div",
                                          { staticClass: "communicate" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "auto",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(item.gmtCreate) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.senderName
                                                        ) +
                                                        "（" +
                                                        _vm._s(
                                                          item.senderType == 1
                                                            ? "客户"
                                                            : item.senderType ==
                                                              2
                                                            ? "临勤"
                                                            : item.senderType ==
                                                              3
                                                            ? "保安公司"
                                                            : item.senderType ==
                                                              4
                                                            ? "保安公司员工"
                                                            : "平台客服"
                                                        ) +
                                                        "）\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "img",
                                                    staticStyle: {
                                                      "margin-right": "0",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          item.senderAvatar ||
                                                          require("@/assets/imgs/headImg.png"),
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                              },
                                              [
                                                item.message.type == 0 ||
                                                item.message.type == 2 ||
                                                item.message.type == 3 ||
                                                item.message.type == 4 ||
                                                item.message.type == 5 ||
                                                item.message.type == 6
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "message",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              item.message
                                                                .context
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 1
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "message",
                                                      },
                                                      [
                                                        _c("el-image", {
                                                          staticStyle: {
                                                            width: "200px",
                                                            height: "200px",
                                                          },
                                                          attrs: {
                                                            src: item.message
                                                              .context,
                                                            alt: "",
                                                            "preview-src-list":
                                                              [
                                                                item.message
                                                                  .context,
                                                              ],
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 7
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goJob(
                                                              item.message.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-card",
                                                          {
                                                            staticClass:
                                                              "box-card1 other",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          任务编号：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .jobNo
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardStatus",
                                                                  },
                                                                  [
                                                                    item.message
                                                                      .status ==
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "待支付"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    1
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "待发布"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    2
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "发布中"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    3
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已收单"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    4
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "实做中"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    5
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已取消"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .status ==
                                                                    6
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已结算"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        任务名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        地址：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .address
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        时间：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobStart
                                                                    ) +
                                                                    "-" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobEnd
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          单价：￥" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .unitPrice
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          任务时长：" +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "maxTime"
                                                                          )(
                                                                            item
                                                                              .message
                                                                              .hour *
                                                                              60
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          总金额：￥" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .price
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 8
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.gocomplaint(
                                                              item.message
                                                                .jobComplainId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-card",
                                                          {
                                                            staticClass:
                                                              "box-card1 other",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          投诉编号：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .complainNo
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardStatus",
                                                                  },
                                                                  [
                                                                    item.message
                                                                      .jobComplainStatus ==
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "未处理"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .jobComplainStatus ==
                                                                    1
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已处理"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.message
                                                                      .jobComplainStatus ==
                                                                    2
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "已撤销"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        任务名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        被投诉人名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .respondentName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        投诉人名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .complainantName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        投诉原因：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .complainMemo
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          提交时间：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .submitAt
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          责任人类型：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .dutyType ==
                                                                            1
                                                                            ? "用户"
                                                                            : item
                                                                                .message
                                                                                .dutyType ==
                                                                              2
                                                                            ? "保安(临勤)"
                                                                            : "保安(公司)"
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 9
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.godefault(
                                                              item.message
                                                                .violateLogId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-card",
                                                          {
                                                            staticClass:
                                                              "box-card1 other",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          违约编号：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .violateLogNo
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardStatus",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .violateLogStatus ==
                                                                            0
                                                                            ? "待支付"
                                                                            : "已支付"
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        任务名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        违约类型：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .voilateTypeTitle
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        违约规则：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .voilateMemo
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          违约：￥" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .violateAmount
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          退还：￥" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .refundAmount ||
                                                                            0
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.message.type == 10
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goappeal(
                                                              item.message
                                                                .appealId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-card",
                                                          {
                                                            staticClass:
                                                              "box-card1 other",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTop",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardNum",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          考勤申诉编号：" +
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .appealNo
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cardStatus",
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .message
                                                                            .operateStatusTitle
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        任务名称：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .jobName
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        考勤日期：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .dueAtIn
                                                                    ) +
                                                                    "-" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .dueAtOut
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        打卡状态：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .signStatusTitle
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "5px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        申诉原因：" +
                                                                    _vm._s(
                                                                      item
                                                                        .message
                                                                        .appealReason
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm.tableData1.length == 0
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      margin: "50px auto",
                                    },
                                  },
                                  [_vm._v("暂无数据")]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-pagination", {
                          attrs: {
                            layout: "prev, pager, next",
                            total: _vm.listNum,
                            "page-size": _vm.pageSize1,
                            small: "",
                          },
                          on: { "current-change": _vm.moreList },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "打卡记录", name: "1" } },
                      [
                        _vm.tableData2.length > 0
                          ? _c(
                              "div",
                              { staticClass: "daka" },
                              [
                                _c(
                                  "el-timeline",
                                  _vm._l(
                                    _vm.tableData2,
                                    function (item, index) {
                                      return _c(
                                        "el-timeline-item",
                                        {
                                          key: index,
                                          attrs: {
                                            timestamp: item.timestamp,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("el-card", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "justify-content":
                                                    "space-between",
                                                  "align-items": "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c("h4", [
                                                      _vm._v(
                                                        "第" +
                                                          _vm._s(item.dayNum) +
                                                          "天(" +
                                                          _vm._s(item.signDay) +
                                                          ")"
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p"),
                                                    _vm._l(
                                                      item.signItemList,
                                                      function (
                                                        subItem,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  subItem.signType ==
                                                                    0
                                                                    ? "上班打卡"
                                                                    : "下班打卡"
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  subItem.realSignTime
                                                                ) +
                                                                " ("
                                                            ),
                                                            _c("span", {
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.getSignStatusName(
                                                                      subItem.signStatus
                                                                    )
                                                                  ),
                                                              },
                                                            }),
                                                            _vm._v(
                                                              " )\n                          "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p"),
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _vm.detail.status != 5 &&
                                                (!item.signItemList[0]
                                                  .realSignTime ||
                                                  !item.signItemList[1]
                                                    .realSignTime ||
                                                  item.signItemList[0]
                                                    .signStatus == -1)
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        staticClass: "btn",
                                                        staticStyle: {
                                                          height: "30px",
                                                          "line-height": "6px",
                                                        },
                                                        attrs: {
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.correct(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("修正")]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tableData2.length == 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  margin: "50px auto",
                                },
                              },
                              [_vm._v("暂无数据")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "考勤修正",
            visible: _vm.dialogFormVisible,
            "before-close": _vm.handleClose,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _vm.selectData2.signItemList
            ? _c("div", [
                _vm._v(
                  "请确认是否要对【" +
                    _vm._s(_vm.selectData.bodyguardName) +
                    " " +
                    _vm._s(_vm.selectData2.signDay) +
                    " (第" +
                    _vm._s(_vm.selectData2.dayNum) +
                    "天)】考勤进行修正，修正后他的考勤和结算金额将改成正常"
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "30px", "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  staticStyle: { margin: "0 auto", display: "block" },
                  attrs: { type: "primary" },
                  on: { click: _vm.confrimCorrect },
                },
                [_vm._v("修正保存")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "派单设置",
            visible: _vm.dialogFormVisible1,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible1 = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "ruleForm", attrs: { model: _vm.ruleForm2 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 4 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入名称" },
                            on: { focus: _vm.clearData },
                            model: {
                              value: _vm.ruleForm2.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm2, "name", $$v)
                              },
                              expression: "ruleForm2.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入手机号" },
                            on: { focus: _vm.clearData },
                            model: {
                              value: _vm.ruleForm2.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm2, "phone", $$v)
                              },
                              expression: "ruleForm2.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "身份状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm2.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm2, "status", $$v)
                                },
                                expression: "ruleForm2.status",
                              },
                            },
                            _vm._l(_vm.tableData4, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.getUserList()
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm1()
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
            _vm._v(
              "\n      需求人数：" +
                _vm._s(_vm.detail.membersNum) +
                "，已参与人数：" +
                _vm._s(_vm.detail.readiesNum) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
            _vm._v("搜索总数：" + _vm._s(_vm.tableData3.length)),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              ref: "singleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData3,
                "highlight-current-row": "",
                "max-height": "250",
              },
              on: { "current-change": _vm.selectItem },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "50" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", {
                          class: [
                            scope.row.id == _vm.selectUserID
                              ? "select"
                              : "noselect",
                          ],
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "姓名" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.accountType == 0
                              ? scope.row.companyName
                              : scope.row.cardName
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.accountType == 0
                              ? "企业"
                              : scope.row.accountType == 0
                              ? "企业员工"
                              : "临勤"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "30px", "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.allocation()
                    },
                  },
                },
                [_vm._v("派单")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetForm2()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }